'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MessageBox = function () {
    function MessageBox($ionicPopup, ionicToast) {
        _classCallCheck(this, MessageBox);

        this.ionicToast = ionicToast;
        this.$ionicPopup = $ionicPopup;
    }

    /**
     * @param  {string} title title which is displayed in the message box
     * @param  {string} content message to be displayed in the message box
     * @return {void}
     */


    _createClass(MessageBox, [{
        key: 'show',
        value: function show(title, content) {
            this.$ionicPopup.alert({
                title: '<b>' + this.toProperCase(title) + '</b>',
                template: content,
                okType: 'button-picton-blue'
            });
        }

        /**
         * Show successful save message box
         * @param  {string} entity The name of the entity in capital case. eg CAMAIGN, CAMPAIGN_CONTACT
         * @param  {string} action The action during which the message is to be displayed. eg SAVE, EDIT, DELETE
         * @return {void}
         */

    }, {
        key: 'showSuccessMessage',
        value: function showSuccessMessage(entity, action) {
            var messageTemplate = '{{"' + entity + '_' + action + '_SUCCESS_MSG" | translate}}';
            this.$ionicPopup.alert({
                title: '<b>' + this.toProperCase(action) + ' successful</b>',
                template: messageTemplate,
                okType: 'button-picton-blue'
            });
        }

        /**
         * Show successful fail message box
         * @param  {string} entity The name of the entity in capital case. eg CAMAIGN, CAMPAIGN_CONTACT
         * @param  {string} action The action during which the message is to be displayed. eg SAVE, EDIT, DELETE
         * @return {void}
         */

    }, {
        key: 'showFailMessage',
        value: function showFailMessage(entity, action, error) {
            var messageTemplate = '{{"' + entity + '_' + action + '_FAIL_MSG" | translate}}';
            this.$ionicPopup.alert({
                title: '<b>' + this.toProperCase(action) + ' failed</b>',
                template: messageTemplate,
                okType: 'button-picton-blue'
            });
        }
    }, {
        key: 'showToaster',
        value: function showToaster(message, position, stick) {
            this.ionicToast.show(message, position, stick, 2000);
        }
    }, {
        key: 'hideToaster',
        value: function hideToaster() {
            this.ionicToast.hide();
        }
    }, {
        key: 'toProperCase',
        value: function toProperCase(text) {
            return text.toLowerCase().replace(/(^[a-z]| [a-z]|-[a-z])/g, function ($1) {
                return $1.toUpperCase();
            });
        }
    }]);

    return MessageBox;
}();

exports.default = MessageBox;


/** WEBPACK FOOTER **
 ** ./src/app/services/messageBox.js
 **/